import * as types from '../actions/actionTypes';
import initialState from './initialState';
import {sortBy, some, filter} from 'lodash';

export default function regionsReducer(state = initialState.regions, action) {
  switch (action.type) {
    case types.LOAD_REGIONS_SUCCESS:
      return {...action.regions};
    case types.SAVE_SUBURBS_TOREGION_SUCCESS:
      return {...state, items: state.items.map(x => {
        let returnVal = {...x};
        if(returnVal.id == action.regionId){
          let suburbs = [...returnVal.suburbs];
          if(!_.some(suburbs, x => x.id == action.suburb.id)){
            suburbs.push(action.suburb);
          }
          returnVal.suburbs = _.sortBy(suburbs, x => x.name.toLowerCase());
        }
        return returnVal;
      })};
    case types.REMOVE_SUBURB_FROMREGION_SUCCESS:
      return {...state, items: state.items.map(x => {
        let returnVal = {...x};
        if(returnVal.id == action.regionId){
          returnVal.suburbs = [...returnVal.suburbs.filter(y => y.id != action.suburb.id)];
        }
        return returnVal;
      })};
    case types.CREATE_REGION_SUCCESS:
      let regions = [...state.items];
      if(!_.some(regions, x => x.id==action.region.id)){
        regions.push(action.region);
      }
      return {...state, items: _.sortBy(regions, x => x.name.toLowerCase())};
    case types.UPDATE_REGION_SUCCESS:
      let regionsUpdate = [...state.items].map(x => {
        let returnVal = {...x};
        if(x.id == action.region.id){
          returnVal.isInactive = action.region.isInactive;
        }
        return returnVal;
      });

      return {...state, items: regionsUpdate};
    case types.DELETE_REGION_SUCCESS:
      return {...state, items: [..._.filter(state.items, x => x.id!=action.region.id)]};
    default:
      return state;
  }
}
